export default {
  COMMENT_OPTIONAL: 'Optional',
  COMMENT_DISABLED: 'Disabled',
  COMMENT_REQUIRED: 'Required'
} as Dictionary<homeworkCommentRequired>
